import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Login from '../Login';
import { LOGIN_TYPES } from '../../../utils/constant';
import { IResetPassword } from '../../../models/loginRequest';
import { useAppDispatch } from '../../../app/store';
import { resetPassword } from '../authApi';
import ModalComponent from '../../../components/Modal';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ResetPassword: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { tokenForgotPassword } = useParams<{ tokenForgotPassword: string }>();

    //Handle click event of reset password button
    const onFinish = (values: any) => {
        setLoading(true);
        const resetPasswordRequest: IResetPassword = {
            email: values.email,
            password: values.newPassword,
            token: tokenForgotPassword ?? "",
            password_confirmation: values.confirmPassword
        };

        //Trigger api call for reset password
        dispatch(resetPassword(resetPasswordRequest))
            .unwrap()
            .then((response) => {
                setLoading(false);
                if (response?.status && response?.status === 'success') {
                    setIsModalVisible(true);
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Failed to reset password:', error);
            });
    }

    //Handle click event on reset password event api response modal message ok button
    const handleModalOk = () => {
        setLoading(false);
        setIsModalVisible(false);
        navigate('/login')
    };

    return (
        <>
            <Login
                loading={loading}
                onFinish={onFinish}
                loginType={LOGIN_TYPES.RESET_PASSWORD} 
                backToLogin={handleModalOk}
                />

            <ModalComponent
                title={t('success')}
                visible={isModalVisible}
                okButtonText={t('btn.login')}
                onOk={handleModalOk}
                onCancel={handleModalOk}
                isClosable={false}
                description={t('reset-password.response.success.desc')} />
        </>
    );
};

export default ResetPassword;